// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3W5zG","signatureBlock":"Footer_signatureBlock__1VgLg","signature":"Footer_signature__3JoVH"};